<template>
    <div class="rss-page page">
        <v-skeleton-loader type="card" v-if="loading" />
        <RssCard 
            v-else-if="podcasts.length" 
            v-for="(rss, index) in podcasts" 
            :key="rss.title" 
            :item="rss" 
            :isPodcast="isPodcast" 
            :podcasts="podcasts"
            :index="index"
        />
        <NewsFeedEmpty v-else title='RSS/Podcasts is empty at the moment.' description='Check back later.' />
        <ScrollToTopButton />
    </div>
</template>
<script>
import RssCard from '@/components/Rss/RssCard'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty'
import ScrollToTopButton from '@/components/ScrollToTopButton'
import { mapActions, mapGetters } from 'vuex'
export default {
    components: {
        RssCard,
        NewsFeedEmpty,
        ScrollToTopButton
    },
    methods: {
        ...mapActions('rss', ['getPodcasts']),

        getRSSPodcasts() {
            this.getPodcasts(this.$route.query.feed_id)
        }
    },
    computed: {
        ...mapGetters('rss', ['podcasts', 'loading']),

        isPodcast() {
            return !!(this.podcasts.length && this.podcasts[0].upload)
        }
    },
    watch: {
        '$route.query.feed_id': {
            handler(newValue) {
                this.getRSSPodcasts(newValue)
            }
        }
    },
    created() {
        this.getRSSPodcasts()
    }
}
</script>
<style lang="scss">
.rss-page {
    a {
        text-decoration: none;
    }
}
</style>